// ActionCable consumer + per-channel subscription helper.
// One consumer per page (lazy-init); per-conversation subscriptions are
// returned to callers as `{ unsubscribe }` objects.

import { createConsumer } from "@rails/actioncable"

let consumer = null

function getConsumer(url = "/cable") {
  if (!consumer) consumer = createConsumer(url)
  return consumer
}

// Subscribe to an Agent::ConversationChannel. Returns an unsubscribe
// function. The `onMessage` callback receives the broadcasted payload
// (the JSON shape from Agent::ConversationChannel.payload_for).
export function subscribeToConversation(conversationId, { onMessage, onConnected, onDisconnected }) {
  const cable = getConsumer()
  const sub = cable.subscriptions.create(
    { channel: "Agent::ConversationChannel", conversation_id: conversationId },
    {
      connected()    { onConnected   && onConnected()   },
      disconnected() { onDisconnected && onDisconnected() },
      received(data) { onMessage     && onMessage(data) },
    },
  )
  return () => sub.unsubscribe()
}
